import styled from '@emotion/styled';
import { LinkButton } from '@travelnest/merlin.button';
import { IconButton } from '@travelnest/merlin.button-icon';
import { Icon } from '@travelnest/merlin.icon';
import * as React from 'react';

const StyledIconButton = styled(IconButton)`
	height: 40px;
	width: 40px;
	margin-right: 10px;
`;
interface IBackButtonProps {
	to: string | (() => void);
}

export const BackButton: React.FC<IBackButtonProps> = ({ to }) => {
	return typeof to === 'string' ? (
		<LinkButton to={to} label="Back" className="back-button">
			<span className="back-button__link-icon">
				<Icon colour="black" icon="left" />
			</span>
		</LinkButton>
	) : <StyledIconButton icon="left" iconPosition="center" colour="darkGrey" onClick={to} />;
};
